import React, { useState, useEffect } from 'react';
import { Button, StyleSheet, TextInput, TouchableOpacity, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import api from '../../../../../utils/api';
import { useQuery } from '@tanstack/react-query';
import Header from '../../../../../navigation/Header';
import { ScrollView } from 'react-native-gesture-handler';
import IconButton from '../../../../../components/IconButton';
import FilePicker from '../../../../../components/FilePicker';
import useFormSubmit from '../../../../../hooks/useFormSubmit';
import useActiveResidentCommunity from '../../../../../hooks/useActiveResidentCommunity';
import { useToast } from 'react-native-toast-notifications';
import { FeeInfoBlock } from './BankTransferPaymentScreen';
import { StackActions } from '@react-navigation/native';



export default function BankTransferEvidenceUploadScreen({ route, navigation }) {
  const { feeUnits, return_to_unit_fee_id } = route.params
  const [selectedImage, setSelectedImage] = useState();
  const { community, communityId } = useActiveResidentCommunity()
  const toast = useToast()
  const insets = useSafeAreaInsets();



  //! 
  //! 
  //! Cuando se puedan elegir multiples pagos arreglar esto!!
  //! 
  //! 
  const feeUnit = feeUnits?.[0]



  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: () => {
      const popToAction = StackActions.popTo('Resident.Fees.Detail', {
        // unit_fee_id: feeUnit.uuid,
        unit_fee_id: return_to_unit_fee_id,
      });

      navigation.dispatch(popToAction);
    },
    onError: (error) => { },
    successToastMessage: "Comprobante enviado",
    endpoint: `/communities/${communityId}/payments/evidences`,
  })


  function sendForm() {
    const feesUnitIds = feeUnits.map(feeUnit => feeUnit.uuid)

    const data = {
      // fee_unit_ids: [feeUnit.uuid],
      fee_unit_ids: feesUnitIds,
      image: selectedImage.uuid,
    }

    console.log(data)
    submitForm(data)
  }


  return (
    <View style={tw`flex-1 bg-white`}>
      <View style={tw`bg-secondary rounded-b-2xl mb-6`}>
        <Header showBackButton backButtonColor='white' style={tw`bg-transparent`}>
          <Text style={tw`text-xl text-white mt-0.5`}>Pagar adeudo</Text>
        </Header>

        <View style={tw`px-5`}>
          <FeeInfoBlock feeUnit={feeUnit} compact={true} />
        </View>
      </View>

      <View style={tw`px-5 flex-1`}>
        <Text style={tw`text-gray-600 text-center text-lg mb-4`}>Comprobante de pago</Text>

        <Text style={tw`text-center text-orange-400 text-sm mb-4 px-4`}>El comprobante será revisado y aprobado por la administración</Text>


        <View style={tw`w-full h-[350px] bg-gray-100 rounded-xl`}>
          <FilePicker
            onFileSelected={file => setSelectedImage(file)}
            postUrl={`communities/${communityId}/images`}
            style={{ image: tw`w-full h-full` }}
            hideButton={!!selectedImage}
          />

          {
            !!selectedImage &&
            <IconButton title={'Elegir otro archivo'} style={tw`absolute bottom-8 right-0 rounded-r-0`} />
          }
        </View>
      </View>


      <View style={{ paddingBottom: insets.bottom }}>
        <IconButton
          disabled={!selectedImage || isSubmitting}
          title={isSubmitting ? 'Enviando' : 'Enviar comprobante'}
          style={tw`py-3 w-full rounded-b-0 rounded-t-xl`}
          icon=''
          onPress={sendForm}
        />

      </View>
    </View>
  )
}